import { Document, Page, Text, View, StyleSheet, Font } from '@react-pdf/renderer'
import ReactDOMServer from 'react-dom/server'
import PoppinsBold from '../Fonts/Poppins/Poppins-Bold.ttf';
import PoppinsRegular from '../Fonts/Poppins/Poppins-Regular.ttf';
import Html from 'react-pdf-html'

function StudentReport({reportData}){
    const element = (
    <html>
      <head>
        <style>
          {`
          table{
            border-collapse:collapse;
            border:1px solid lightgrey;
            font-family: Poppins;
            font-size:13px;
          }
          `}
        </style>
      </head>
      <body>
        <p>Tələbə</p>
        <table>
          <thead>
            <tr>
              <th>Test1</th>
              <th>Test2</th>
              <th>Test3</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>11</td>
              <td>111</td>
            </tr>
            <tr>
              <td>2</td>
              <td>22</td>
              <td>222</td>
            </tr>
          </tbody>
        </table>
      </body>
    </html>
  )
  const html = ReactDOMServer.renderToStaticMarkup(element)
  Font.register({
      family: 'Poppins',
      fonts: [
        { src: PoppinsRegular, fontWeight: 'regular' },
        { src: PoppinsBold, fontWeight: 'bold' }
      ],
    });

  const styles = StyleSheet.create({
    page: { padding: 30,fontFamily:'Poppins' },
    section: { margin: 10, padding: 10, flexGrow: 1 }
  })
  return (
    <Document>
      <Page size='A4' orientation='landscape' style={styles.page}>
        <View style={styles.section}>
          <Text>This is a sample PDF generated from React0!</Text>
        </View>
      </Page>
      <Page size='A4' orientation='landscape' style={styles.page}>
        <View>
          <Text>Tələbələr</Text>
        </View>
        <Html>{html}</Html>
      </Page>
    </Document>
  )
}


export default StudentReport;